import React from 'react'
import CreateOrder from '../components/CreateOrder/CreateOrder'

const CreateOrderPage = () => {
    return <CreateOrder />
}

export default CreateOrderPage
